import {calcUserScore} from 'helpers/common-helper';
import {getDefaultExposure} from 'helpers/player-helper';
import Action from 'actions';
import BasePlayer from 'services/sports/nhl/player/player';
import Const from 'constants';
import NhlTeamStackingAction from 'components/organisms/nhl-team-stacking/actions';
import NhlLegacyTeamStackingAction from 'components/organisms/nhl-legacy-team-stacking/actions';
import {getPlayerProjOwnFunctionality} from 'helpers/projected-ownership';

export default class PlayerClassic extends BasePlayer {
    getExpandedEntityParams({incomingValues = {}}) {
        const {userPointsType = 'adminPoints'} = incomingValues;
        const expandedPlayer = super.getExpandedEntityParams({incomingValues});
        const userPoints = parseFloat(expandedPlayer[userPointsType]);

        return {
            ...expandedPlayer,
            [Const.EXCLUDED_BY_LINE_GROUPS_RANGE]: false,
            userPoints,
            ppLine: parseInt(expandedPlayer.ppLine * 1),
            lineGroup: parseInt(expandedPlayer.lineGroup * 1),
            userLineGroup: parseInt(expandedPlayer.lineGroup * 1),
            userPpLine: parseInt(expandedPlayer.ppLine * 1),
            userScore: calcUserScore(userPoints, expandedPlayer.salary, this.userScoreMultiplier),
            projOwn: {...getPlayerProjOwnFunctionality(expandedPlayer)},
            isExcludedByFilter() {
                return this[Const.EXCLUDED_BY_LINE_GROUPS_RANGE];
            },
            include() {
                this.includeBy([Const.EXCLUDED_BY_LINE_GROUPS_RANGE]);
            },
            isGoalie() {
                return this.positionName === 'G';
            },
            isDefenseman() {
                return this.positionName === 'D';
            },
            resetExposure() {
                this.exposureMin = getDefaultExposure('min');
                this.exposureMax = getDefaultExposure('max');
                this.captain_exposureMin = getDefaultExposure('min');
                this.captain_exposureMax = getDefaultExposure('max');
            },
            resetPPLine() {
                this.userPpLine = this.ppLine;
            },
            resetLineGroups() {
                this.userLineGroup = this.lineGroup;
            },
            isFitForLineup(substitutablePlayer) {
                const substitutePlayerLineupPositions = this.positionName.split('/');
                if (substitutablePlayer.positionInLineup === Const.POSITION_UTIL) {
                    return substitutePlayerLineupPositions.some((position) => inArray(position, ['C', 'W', 'D']));
                }

                return substitutePlayerLineupPositions.some(
                    (position) => substitutablePlayer.positionInLineup === position,
                );
            },
        };
    }

    afterGettingPlayers({incomingValues: {dispatch}}) {
        const {playersData} = Action.getState();
        const {lineGroupFilter} = playersData;

        const players = playersData.players.all();

        let teams = {};
        Object.values(players).map((player) => {
            if (!teams.hasOwnProperty(player.team)) {
                teams[player.team] = {
                    implied_run_totals: 0,
                };
            }
            if (!teams[player.team].implied_run_totals) {
                teams[player.team].implied_run_totals = player.implied_run_totals;
            }
        });

        dispatch(Action.do('unsetTeamDetails'));
        dispatch(Action.set('TeamDetails', teams));

        dispatch(Action.set('LineGroups', lineGroupFilter.lineGroups));
    }

    loadExtraPlayerDataFromStore({incomingValues: {dispatch, data}}) {
        if (data.hasOwnProperty('nhlTeamStackingSettings')) {
            dispatch(NhlTeamStackingAction.setNhlTeamStackingSettingsFromStorage(data.nhlTeamStackingSettings));
        }

        if (data.hasOwnProperty('nhlLegacyTeamStackingSettings')) {
            dispatch(NhlLegacyTeamStackingAction.setNhlLegacyTeamStackingSettingsFromStorage(data.nhlLegacyTeamStackingSettings));
        }

        if (data.hasOwnProperty('useOpposingGoalie')) {
            dispatch(Action.set('UseOpposingGoalieFromStorage', data.useOpposingGoalie));
        }

        if (data.hasOwnProperty('flexMaxExposurePositions')) {
            dispatch(Action.set('FlexMaxExposurePositionsFromStorage', data.flexMaxExposurePositions));
        }

        return super.loadExtraPlayerDataFromStore({incomingValues: {dispatch, data}});
    }
}
